import { useCallback, useMemo } from 'react';
import _ from 'lodash';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import useMultipleEmployerIdsFeatureFlag from './useMultipleEmployerIdsFeatureFlag';
interface Params {
  isMultipleEmployerMode?: boolean;
}
interface ReturnValue {
  employer_id?: string;
  employer_ids?: string[] | string;
}
const useGetEmployeeIdParam = (params?: Params) => {
  const isEnabled = useMultipleEmployerIdsFeatureFlag();

  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isPartnerOrDistributor = useMemo(() => {
    return type === OrganizationTypes.partner || type === OrganizationTypes.distributor;
  }, [type]);
  const isEmployer = useMemo(() => {
    return (
      type === OrganizationTypes.company ||
      type === OrganizationTypes.employer ||
      type === OrganizationTypes.subsidiary
    );
  }, [type]);

  const handleGetEmployerIdParam = useCallback(
    (employeeId?: string, employeeIds?: string[]): ReturnValue => {
      if (!isEnabled || params?.isMultipleEmployerMode == false) {
        return {
          employer_id: employeeId,
        };
      }

      if (isEmployer) {
        return {
          employer_id: employeeId,
        };
      }

      if (isPartnerOrDistributor) {
        return {
          employer_ids: _.isArray(employeeIds) ? employeeIds : employeeId ? [employeeId] : [],
        };
      }
      if (!employeeIds) {
        if (employeeId) {
          return { employer_id: employeeId };
        }
        return {};
      }
      return { employer_id: employeeId };
    },
    [isEmployer, isEnabled, isPartnerOrDistributor, params?.isMultipleEmployerMode]
  );

  return handleGetEmployerIdParam;
};

export default useGetEmployeeIdParam;
